import { FormattedMessage } from 'react-intl';

// assets
import AdminTools from 'assets/icons/Admin_Tools.png';
import AdminDashboard from "assets/icons/Admin_Dashboard.png";
import BookUpload from 'assets/icons/Books_Upload.png';

// ==============================|| MENU ITEMS - Admin PAGE ||============================== //

const icons = {
    AdminTools,
    AdminDashboard,
    BookUpload
};

const AdminPage = {
    id: 'admin-page',
    title: <FormattedMessage id="admin-page-title" />,
    caption: <FormattedMessage id="admin-page-caption" />,
    icon: icons.AdminTools,
    type: 'group',
    children: [
        {
            id: 'tools',
            title: <FormattedMessage id="Admin" />,
            type: 'collapse',
            icon: icons.AdminTools,
            children: [
                {
                    id: 'dashboard',
                    title: <FormattedMessage id="Dashboard" />,
                    type: 'item',
                    url: '/admin/dashboard',
                    icon: icons.AdminDashboard,
                    target: false,
                },
                {
                    id: 'bookUpload',
                    title: <FormattedMessage id="Upload Books" />,
                    type: 'item',
                    url: '/admin/books/upload',
                    icon: icons.BookUpload,
                    target: false,
                }
            ]
        }
    ]
};

export default AdminPage;
